export const authEmailSelector = (state) => state?.auth?.email ?? null;
export const authUserIdSelector = (state) => state?.auth?.user_id ?? null;
export const authIsLoadingSelector = (state) => state?.auth?.isLoading;
export const authCurrencySelector = (state) => state?.auth?.currency;
